var activityPlaceTypes = [
    { "label": "مالکیت", value: 0 },
    { "label": "اجاره", value: 1 },
];

export default activityPlaceTypes;
